import type { Router } from 'vue-router'
import { localizeLocation } from '~/utils/locale'

// On a /fr or /de market makeLangRoutes registers every route under a literal
// `/fr` segment (not a `:lang` param), so a link to a bare '/products' matches
// nothing and renders href="/products". lang-guard rewrote a client-side click on
// it, but a fresh request for the bare URL (a crawler, a new tab, a full load)
// served the English page. SBtn and several NuxtLink callers already localized
// their `to` with useLocalizedTo; a bare NuxtLink did not. AB#64915
//
// Prefixing in `router.resolve` covers every router-resolved link href, so link
// callers no longer need useLocalizedTo (their double call is harmless). Every
// string or `{ path }` caller of `router.resolve` gets the prefix on purpose.
// Not covered: `router.push` resolves internally and still goes through
// lang-guard; a NuxtLink with `target="_blank"` and a string `to` builds its href
// without `router.resolve`, so localize that `to` with useLocalizedTo; CMS anchors
// rendered through v-html (nuxt2 left those bare too).
export const localizeRouterResolve = (router: Router, getLang: () => string | undefined) => {
  const resolve = router.resolve
  router.resolve = ((...args: Parameters<Router['resolve']>) => {
    args[0] = localizeLocation(args[0], getLang())
    return resolve(...args)
  }) as Router['resolve']
}

export default defineNuxtPlugin(() => {
  const localeStore = useLocaleStore()
  localizeRouterResolve(useRouter(), () => localeStore.subLocaleLang)
})
